export const SET_IS_REDESIGNED_FLOW = 'REDESIGNED_FLOW/SET_IS_REDESIGNED_FLOW';
export const SET_HEADER_SETTINGS = 'REDESIGNED_FLOW/SET_HEADER_SETTINGS';
export const SET_CURRENT_BODY_TITLE = 'SET_CURRENT_BODY_TITLE';
export const SET_TARGET_BODY_TITLE = 'SET_TARGET_BODY_TITLE';
export const SET_GOALS_TITLES = 'SET_GOALS_TITLES';
export const SET_REAL_FITNESS_LEVEL = 'SET_REAL_FITNESS_LEVEL';
export const SET_USER_AGE = 'SET_USER_AGE';
